import axios from 'axios/index';
import MockAdapter from 'axios-mock-adapter';

import login from './login.mock'
import menu from './menu.mock'

export default {
  bootstrap() {
    let mock = new MockAdapter(axios)
    let result = {
      code: 0,
      msg: "",
      data: {}
    };
    login.call(this,mock,result);
    menu.call(this,mock,result);
  }
}
